import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  /*
   * RELATÓRIOS PERSONALIZADOS ("visões") — rota de RESERVA, parametrizada.
   *
   * O caminho normal é outro: `rotas-dinamicas.service.ts` registra uma rota por relatório do
   * catálogo, com nome único, porque o menu navega por NOME e sem params. Esta aqui existe para o
   * acesso DIRETO pela URL — link colado, favorito do navegador, aba restaurada — que pode
   * acontecer antes de o catálogo ter sido carregado.
   *
   * Sem `permissions`: o acesso ao módulo é decidido pelo próprio menu (permissão ACESSO_REPORTS,
   * 1890000002, aplicada pelo Kernel ao montar a árvore). Repetir a permissão aqui criaria uma
   * segunda fonte de verdade que sairia de sincronia na primeira mudança.
   */
  {
    description: 'Relatório Personalizado',
    path: '/ferramentas/reports/personalizado/:idReport',
    name: 'report_personalizado',
    component: () => import('@/views/ferramentas/reports/personalizado/Index.vue'),
    meta: {
      isLegacy: false,
    },
    goesToMenu: false,
  },
  /*
   * EDITOR DAS VISÕES dos relatórios personalizados: criar, alterar e excluir as linhas de
   * REPORTS_PERSONALIZADOS / REPORTS_CAMPOSFILTRO e o gráfico de cada visão. Permissão própria
   * (escrever SQL de leitura sobre a base do cliente não é o mesmo que consultar relatório).
   */
  {
    description: 'Editor de Relatórios Personalizados',
    path: '/ferramentas/reports/editor',
    name: 'reports_personalizados_editor',
    component: () => import('@/views/ferramentas/reports/editor/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [eTipoPermissao.EDITORRELATORIOSPERSONALIZADOSNOVO_MENU_1890000099],
    },
    goesToMenu: true,
  },
  {
    description: 'Cabeçalhos e Rodapés',
    path: '/ferramentas/cabecalho_rodape',
    name: 'cabecalho_rodape',
    component: () => import('@/views/ferramentas/reports/CabecalhoRodape.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_CABECALHOSERODAPES_MENU_2500100300
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Cabeçalhos e Rodapés',
    path: '/ferramentas/create_cabecalho_rodape/:id?',
    parent: 'cabecalho_rodape',
    name: 'create_cabecalho_rodape',
    component: () => import('@/views/ferramentas/reports/CreateCabecalhoRodape.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_CABECALHOSERODAPES_MENU_2500100300
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Fonte de Dados',
    path: '/ferramentas/fonte_dados',
    name: 'dados',
    component: () => import('@/views/ferramentas/reports/FonteDados.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_DADOS_MENU_2500100200
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Fonte de Dados',
    path: '/ferramentas/create_fonte_dados/:id?',
    parent: 'dados',
    name: 'create_dados',
    component: () => import('@/views/ferramentas/reports/CreateFonteDados.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_DADOS_MENU_2500100200
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Pastas',
    path: '/ferramentas/pastas',
    name: 'pastas',
    component: () => import('@/views/ferramentas/reports/Pastas.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_PASTAS_MENU_2500100100
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Pastas',
    path: '/ferramentas/create_pastas/:id?',
    parent: 'pastas',
    name: 'create_pastas',
    component: () => import('@/views/ferramentas/reports/CreatePasta.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_PASTAS_MENU_2500100100
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Relatórios',
    path: '/ferramentas/reports',
    name: 'reports',
    component: () => import('@/views/ferramentas/reports/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_RELATORIOS_MENU_2500100400
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Gerador de Relatórios',
    path: '/ferramentas/reports/gerador/:id?',
    name: 'gerador',
    component: () => import('@/views/ferramentas/reports/Gerador.vue'),
    meta: {
      isLegacy: false,
      permissions: [
        eTipoPermissao.FERRAMENTAS_RELATORIOS_MENU_2500100400
      ],
    },
    goesToMenu: true,
  },
]

